<tour-step-template>
  <ng-template let-step="step">
    <div (click)="$event.stopPropagation()" class="custom-tour-step">
      <h3>{{ step?.title }}</h3>
      <p>{{ step?.content }}</p>
      <button mat-icon-button (click)="tourService.end()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </ng-template>
</tour-step-template>
<app-sidenav>
  <router-outlet></router-outlet>
</app-sidenav>
